import { alpha, Theme } from '@mui/material';
import { TAG_GEOMETRY } from '../tag-tokens';

export const MuiChipConfig = {
    defaultProps: {},
    variants: [
        //Filled
        {
            props: { variant: 'filled', color: 'primary' },
            style: ({ theme }: { theme: any }) => {
                return {
                    backgroundColor: alpha(theme.palette.primary.main, 0.08),
                    color: theme.palette.primary.main,
                    '&.MuiChip-clickable:hover': {
                        backgroundColor: alpha(theme.palette.primary.main, 0.04),
                    },
                };
            },
        },
        {
            props: { variant: 'filled', color: 'success' },
            style: ({ theme }: { theme: any }) => {
                return {
                    backgroundColor: alpha(theme.palette.success.main, 0.08),
                    color: theme.palette.success.main,
                    '&.MuiChip-clickable:hover': {
                        backgroundColor: alpha(theme.palette.success.main, 0.04),
                    },
                };
            },
        },
        {
            props: { variant: 'filled', color: 'error' },
            style: ({ theme }: { theme: any }) => {
                return {
                    backgroundColor: alpha(theme.palette.error.main, 0.08),
                    color: theme.palette.error.main,
                    '&.MuiChip-clickable:hover': {
                        backgroundColor: alpha(theme.palette.error.main, 0.04),
                    },
                };
            },
        },
        {
            //TODO [Stas]: review and fix overrides
            props: { variant: 'filled', color: 'warning' },
            style: ({ theme }: { theme: any }) => {
                return {
                    backgroundColor: alpha(theme.palette.warning.main, 0.08),
                    color: theme.palette.warning.main,
                    '&.MuiChip-clickable:hover': {
                        backgroundColor: alpha(theme.palette.warning.main, 0.04),
                    },
                };
            },
        },
        // Opt-in Figma tag form (grid tag component 1660:2440, file CE8J0urthchLLY6jWZMs6O): the
        // square 20px pill becomes a 3px-radius 20px tag whose label carries the tag's own type
        // ramp. The base record sets the shape for every tone; the per-color records below set the
        // fills. Amber is the one hue unreadable as text on its own fill, so it pairs with the
        // default text color on a stronger 32% tint; the rest keep the standard 8%-tint scheme.
        // Use <Chip variant="tag" color="..." />; plain filled chips stay untouched.
        {
            props: { variant: 'tag' },
            style: () => {
                return {
                    height: 20,
                    borderRadius: TAG_GEOMETRY.radius,
                    '& .MuiChip-label': {
                        padding: `0 ${TAG_GEOMETRY.paddingX}`,
                        fontSize: TAG_GEOMETRY.fontSize,
                        lineHeight: TAG_GEOMETRY.lineHeight,
                        fontWeight: TAG_GEOMETRY.fontWeight,
                        whiteSpace: 'nowrap',
                    },
                };
            },
        },
        {
            props: { variant: 'tag', color: 'warning' },
            style: ({ theme }: { theme: any }) => {
                return {
                    backgroundColor: alpha(theme.palette.warning.main, 0.32),
                    color: theme.palette.text.primary,
                    '&.MuiChip-clickable:hover': {
                        backgroundColor: alpha(theme.palette.warning.main, 0.24),
                    },
                };
            },
        },
        ...(['primary', 'success', 'error', 'info'] as const).map((color) => ({
            props: { variant: 'tag', color },
            style: ({ theme }: { theme: any }) => {
                return {
                    backgroundColor: alpha(theme.palette[color].main, 0.08),
                    color: theme.palette[color].main,
                    '&.MuiChip-clickable:hover': {
                        backgroundColor: alpha(theme.palette[color].main, 0.04),
                    },
                };
            },
        })),
        {
            props: { variant: 'tag', color: 'default' },
            style: ({ theme }: { theme: any }) => {
                return {
                    backgroundColor: alpha(theme.palette.text.primary, 0.08),
                    color: theme.palette.text.primary,
                    '&.MuiChip-clickable:hover': {
                        backgroundColor: alpha(theme.palette.text.primary, 0.04),
                    },
                };
            },
        },
        {
            props: { variant: 'filled', color: 'default' },
            style: ({ theme }: { theme: any }) => {
                return {
                    backgroundColor: alpha(theme.palette.text.primary, 0.05),
                    color: theme.palette.text.primary,
                    '&.MuiChip-clickable:hover': {
                        backgroundColor: alpha(theme.palette.text.primary, 0.02),
                    },
                };
            },
        },
    ],
    styleOverrides: {
        root: ({ theme }: { theme: Theme }) => {
            return {
                height: 20,
                borderRadius: 0,
                '&.chip-mod--round-and-text': {
                    borderRadius: '3px',
                    fontSize: theme.typography.fontSize,
                },
            };
        },
        label: {
            padding: '0 7px',
        },
        icon: {
            margin: '0 0 0 7px',
        },
    },
};
